/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Edit_Label_UrlInputs */

const en_samples_edit_label_url = /** @type {(inputs: Samples_Edit_Label_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Label URL`)
};

const es_samples_edit_label_url = /** @type {(inputs: Samples_Edit_Label_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL de etiqueta`)
};

/**
* | output |
* | --- |
* | "Label URL" |
*
* @param {Samples_Edit_Label_UrlInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_edit_label_url = /** @type {((inputs?: Samples_Edit_Label_UrlInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Edit_Label_UrlInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_edit_label_url(inputs)
	return es_samples_edit_label_url(inputs)
});